import Vector from '../../assets/LandingPage/Vector.png';
import StripePricingTable from './StripePricingTable';

export default function Pricing() {
  const isMobile = window.innerWidth < 768;

  return (
    <section
      className="relative w-full py-20 bg-white overflow-hidden min-h-[950px]"
      style={
        isMobile
          ? {
              backgroundColor: '#FFFFFF',
              // backgroundImage: `url(${Vector})`,
              // backgroundRepeat: 'repeat',
              // backgroundSize: 'contain',
            }
          : {}
      }
    >
      {/* DESKTOP BG IMAGE */}
      {!isMobile && (
        <img
          src={Vector}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ zIndex: 0 }}
        />
      )}

      {/* CONTENT WRAPPER */}
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-50 rounded-full px-4 py-2 mb-6">
            <span className="text-[#0088FF] font-semibold text-sm flex flex-row justify-start items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="15"
                viewBox="0 0 20 15"
                fill="none"
                className="mr-2"
              >
                <path
                  d="M8.5 3C8.10603 3 7.71593 3.0776 7.35195 3.22836C6.98797 3.37913 6.65726 3.6001 6.37868 3.87868C6.1001 4.15726 5.87913 4.48797 5.72836 4.85195C5.5776 5.21593 5.5 5.60603 5.5 6C5.5 6.39397 5.5776 6.78407 5.72836 7.14805C5.87913 7.51203 6.1001 7.84274 6.37868 8.12132C6.65726 8.3999 6.98797 8.62087 7.35195 8.77164C7.71593 8.9224 8.10603 9 8.5 9C9.29565 9 10.0587 8.68393 10.6213 8.12132C11.1839 7.55871 11.5 6.79565 11.5 6C11.5 5.20435 11.1839 4.44129 10.6213 3.87868C10.0587 3.31607 9.29565 3 8.5 3ZM7 6C7 5.60218 7.15804 5.22064 7.43934 4.93934C7.72064 4.65804 8.10218 4.5 8.5 4.5C8.89782 4.5 9.27936 4.65804 9.56066 4.93934C9.84196 5.22064 10 5.60218 10 6C10 6.39782 9.84196 6.77936 9.56066 7.06066C9.27936 7.34196 8.89782 7.5 8.5 7.5C8.10218 7.5 7.72064 7.34196 7.43934 7.06066C7.15804 6.77936 7 6.39782 7 6ZM0 2.25C0 1.65326 0.237053 1.08097 0.65901 0.65901C1.08097 0.237053 1.65326 0 2.25 0H14.75C15.0455 0 15.3381 0.0581978 15.611 0.171271C15.884 0.284344 16.1321 0.450078 16.341 0.65901C16.5499 0.867942 16.7157 1.11598 16.8287 1.38896C16.9418 1.66194 17 1.95453 17 2.25V9.75C17 10.0455 16.9418 10.3381 16.8287 10.611C16.7157 10.884 16.5499 11.1321 16.341 11.341C16.1321 11.5499 15.884 11.7157 15.611 11.8287C15.3381 11.9418 15.0455 12 14.75 12H2.25C1.65326 12 1.08097 11.7629 0.65901 11.341C0.237053 10.919 0 10.3467 0 9.75V2.25ZM2.25 1.5C2.05109 1.5 1.86032 1.57902 1.71967 1.71967C1.57902 1.86032 1.5 2.05109 1.5 2.25V3H2.25C2.44891 3 2.63968 2.92098 2.78033 2.78033C2.92098 2.63968 3 2.44891 3 2.25V1.5H2.25ZM1.5 7.5H2.25C2.84674 7.5 3.41903 7.73705 3.84099 8.15901C4.26295 8.58097 4.5 9.15326 4.5 9.75V10.5H12.5V9.75C12.5 9.15326 12.7371 8.58097 13.159 8.15901C13.581 7.73705 14.1533 7.5 14.75 7.5H15.5V4.5H14.75C14.1533 4.5 13.581 4.26295 13.159 3.84099C12.7371 3.41903 12.5 2.84674 12.5 2.25V1.5H4.5V2.25C4.5 2.54547 4.4418 2.83805 4.32873 3.11104C4.21566 3.38402 4.04992 3.63206 3.84099 3.84099C3.63206 4.04992 3.38402 4.21566 3.11104 4.32873C2.83806 4.4418 2.54547 4.5 2.25 4.5H1.5V7.5ZM15.5 3V2.25C15.5 2.05109 15.421 1.86032 15.2803 1.71967C15.1397 1.57902 14.9489 1.5 14.75 1.5H14V2.25C14 2.664 14.336 3 14.75 3H15.5ZM15.5 9H14.75C14.5511 9 14.3603 9.07902 14.2197 9.21967C14.079 9.36032 14 9.55109 14 9.75V10.5H14.75C14.9489 10.5 15.1397 10.421 15.2803 10.2803C15.421 10.1397 15.5 9.94891 15.5 9.75V9ZM1.5 9.75C1.5 10.164 1.836 10.5 2.25 10.5H3V9.75C3 9.55109 2.92098 9.36032 2.78033 9.21967C2.63968 9.07902 2.44891 9 2.25 9H1.5V9.75ZM2.401 13.5C2.66431 13.9563 3.04315 14.3351 3.4994 14.5984C3.95565 14.8618 4.47321 15.0003 5 15H15.25C15.8738 15 16.4915 14.8771 17.0677 14.6384C17.644 14.3997 18.1677 14.0498 18.6088 13.6088C19.0498 13.1677 19.3997 12.644 19.6384 12.0677C19.8771 11.4915 20 10.8738 20 10.25V5C20.0002 4.47323 19.8616 3.95571 19.5983 3.49948C19.335 3.04324 18.9562 2.66438 18.5 2.401V10.25C18.5 11.112 18.1576 11.9386 17.5481 12.5481C16.9386 13.1576 16.112 13.5 15.25 13.5H2.401Z"
                  fill="#0088FF"
                />
              </svg>
              Pricing
            </span>
          </div>

          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            Choose the Right Plan for{' '}
            <span className="bg-gradient-to-r from-[#0088FF] to-[#6583BA] bg-clip-text text-transparent">
              You
            </span>
          </h2>

          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Flexible plans designed to grow with you—choose the right tier based on your team's
            needs, whether you're just getting started or managing a full supplier ecosystem.
          </p>
        </div>

        {/* PRICING CARDS LAYOUT */}
        <div
          className="
        flex
        flex-col
        md:flex-row
        gap-8
        justify-center
        items-stretch
        mb-16
      "
        ></div>

        {/* STRIPE PRICING TABLE */}
        <div id="pricing" className="mt-10">
          <StripePricingTable />
        </div>
      </div>
    </section>
  );
}